import axios from "axios";
import { endpoints } from "../_config";
import { getUserTokenFromStorage } from "../_config/helper.config";

class EmbeddedSectionService {
  /**
   * getEmbeddedSections for a community
   * @param {User} user
   */
  static async getEmbeddedSections(communityId, showAll = false) {
    return axios
      .get(
        endpoints.embeddedSections.getAllEmbeddedSections(communityId, showAll),
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }

  static async getEmbeddedSectionDetailBySlug(community, slug) {
    return axios
      .get(
        endpoints.embeddedSections.getEmbeddedSectionDetailBySlug(
          community.id,
          slug
        ),
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }

  static async createEmbeddedSection(user, community, data) {
    return axios
      .post(
        endpoints.embeddedSections.createEmbeddedSection(community.id),
        data,
        {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        }
      )
      .then((response) => response.data);
  }

  static async updateEmbeddedSection(user, community, section) {
    return axios
      .post(
        endpoints.embeddedSections.updateEmbeddedSection(
          community.id,
          section.id
        ),
        section,
        {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        }
      )
      .then((response) => response.data);
  }
  static async deleteEmbeddedSection(communityId, sectionId) {
    return axios
      .delete(
        endpoints.embeddedSections.updateEmbeddedSection(
          communityId,
          sectionId
        ),
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }

  static async updateEmbeddedSectionSortOrder(communityId, sectionIds) {
    return axios
      .post(
        endpoints.embeddedSections.updateEmbeddedSectionSortOrder(communityId),
        { sectionIds },
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }

  static async getEMbeddedSectionDetailByIdForAdmin(communityId, sectionId) {
    return axios
      .get(
        endpoints.embeddedSections.getEMbeddedSectionDetailByIdForAdmin(
          communityId,
          sectionId
        ),
        {
          headers: {
            Authorization: "Bearer " + getUserTokenFromStorage(),
          },
        }
      )
      .then((response) => response.data);
  }

  static async changeVisibilityEmbeddedSectionInCommunity(
    user,
    community,
    section
  ) {
    return axios
      .post(
        endpoints.embeddedSections.changeVisibilityEmbeddedSectionInCommunity(
          community.id,
          section.id
        ),
        { isActive: !section.isActive },
        {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        }
      )
      .then((response) => response.data);
  }
}

export { EmbeddedSectionService };
